// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const fontSizes = {
  mega: '3rem',
  heading1: '1.5rem',
  heading2: '1.125rem',
  heading3: '0.875rem',
  body: '1rem',
  bodyS: '0.75rem',
  label: '1rem',
  labelS: '0.75rem',
  button: '1rem',
  buttonS: '1rem'
} as const;

export default fontSizes;
